(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/mybets/assets/javascripts/mybets.js') >= 0) return;  svs.modules.push('/widgets/mybets/assets/javascripts/mybets.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

svs.widget = svs.widget || {};
svs.widget.mybets = svs.widget.mybets || {};
const logger = svs.core.log.getLogger('widgets:my_bets');
const correctAllBtn = document.querySelector('.js-mybets-correct-all-btn');
const allCorrectedSection = document.querySelector('.js-mybets-all-corrected-holder');
const ongoingHolderSection = document.querySelector('.js-mybets-widget-ongoing-holder');
const handleClickItem = clickEvent => {
  clickEvent.preventDefault();
  const clickedEl = clickEvent.currentTarget;
  const url = clickedEl.getAttribute('href');
  const _clickedEl$children$ = clickedEl.children[0].dataset,
    productName = _clickedEl$children$.productName,
    sectionName = _clickedEl$children$.sectionName;
  const event = {
    action: sectionName,
    category: 'Personliga rekommendationer',
    opt_label: productName
  };
  svs.components.analytics.trackEvent(event, () => {
    location.href = url;
  });
};
const correctWagers = async () => {
  const customerBetExaminedPromise = svs.core.jupiter.callAsync({
    method: 'POST',
    path: '/customerbet/1/wager/examineall?product=all'
  });
  const wagerExaminedPromise = svs.core.jupiter.callAsync({
    method: 'POST',
    path: '/player/1/examineallwagers'
  });
  const _await$Promise$all = await Promise.all([customerBetExaminedPromise, wagerExaminedPromise]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    customerBetExaminedResponse = _await$Promise$all2[0],
    wagerExaminedResponse = _await$Promise$all2[1];
  return {
    customerBetExaminedResponse,
    wagerExaminedResponse
  };
};
const handleClickCorrectAllButton = async () => {
  correctAllBtn.disabled = true;
  try {
    const _await$correctWagers = await correctWagers(),
      customerBetExaminedResponse = _await$correctWagers.customerBetExaminedResponse,
      wagerExaminedResponse = _await$correctWagers.wagerExaminedResponse;
    if (customerBetExaminedResponse.error) {
      logger.info("/customerbet/1/wager/examineall failed, error code: ".concat(customerBetExaminedResponse.error.code, " message: ").concat(customerBetExaminedResponse.error.message));
    }
    if (wagerExaminedResponse.error) {
      logger.info("/player/1/examineallwager failed, error code: ".concat(wagerExaminedResponse.error.code, " message: ").concat(wagerExaminedResponse.error.message));
    }
    ongoingHolderSection.style.display = 'none';
    allCorrectedSection.style.display = 'block';
  } catch (err) {
    correctAllBtn.disabled = false;
    logger.info("examine wagers failed, error code: ".concat(err.code, " message: ").concat(err.message));
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      actions: [{
        title: 'Okej'
      }],
      area: svs.ui.dialog.area.POPUP,
      branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
      message: [{
        text: 'Ett fel inträffade när dina spel skulle rättas, försök igen senare.'
      }],
      title: 'Något gick visst fel',
      type: svs.ui.dialog.type.DEFAULT
    }));
  }
};
const handleClickButton = clickEvent => {
  clickEvent.preventDefault();
  const clickedEl = clickEvent.currentTarget;
  const url = clickedEl.getAttribute('href');
  const event = {
    action: 'Active_bets',
    category: 'Personliga rekommendationer',
    opt_label: 'Mina spel'
  };
  svs.components.analytics.trackEvent(event, () => {
    location.href = url;
  });
};
setGlobal('svs.widget.mybets', {
  handleClickCorrectAllButton,
  handleClickItem,
  handleClickButton
});

 })(window);